import { render } from "./IconOfferTokens.vue?vue&type=template&id=34febfb8"
import script from "./IconOfferTokens.vue?vue&type=script&lang=js"
export * from "./IconOfferTokens.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__